import { UpcomingAssessment } from "@store/locationsSlice";
import { longLocalizedDate } from "@helpers/dateHelpers";
import classNames from "classnames";
import { format } from "date-fns";
import styles from "./Assessments.module.css";
import { DateBox } from "./DateBox";
import { AssessmentStatus } from "@store/generalTypes";
import { parseStatus } from "@helpers/enumHelper";

export const AssessmentBox = ({
    assessment,
    isFirst,
    isLast,
    lastDate,
    remoteAssessment,
    onSelected
}: AssessmentBoxProps): JSX.Element => {
    const containerClasses = classNames(
        "is-flex",
        styles.boxBackground,
        isFirst ? "is-bordered-top" : "",
        isLast ? "is-bordered-bottom" : "",
        "has-text-ldark-gray"
    );

    const borderColor = "2px #B6CBD6 solid";

    const border = {
        borderTop: borderColor,
        borderLeft: borderColor,
        borderRight: borderColor,
        borderBottom: isLast ? borderColor : ""
    };

    return (
        <a onClick={onSelected} className={containerClasses} style={border}>
            <div className="p-4 minw-100">
                <div className="mx-4 is-flex is-align-items-center is-flex-direction-row is-justify-content-space-between">
                    <div>
                        <p className="has-text-weight-bold is-size-5">
                            {assessment.examineeFirstName} {assessment.examineeLastName}
                        </p>
                        <div className="is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center">
                            <div className="is-flex is-flex-direction-column">
                                <p className="is-size-6">{assessment.examineeEmail || "-"}</p>
                                <p className="is-size-6">{assessment.examineePhoneNumber || "-"}</p>
                            </div>
                        </div>
                    </div>

                    {!lastDate && !!assessment.scheduledFor && (
                        <div className="is-flex is-flex-direction-column">
                            <DateBox date={assessment.scheduledFor} />
                        </div>
                    )}

                    {lastDate && (
                        <div className="">
                            <p className="is-size-6 has-text-weight-bold">
                                {remoteAssessment ? "Link Sent" : "Last Test"}
                            </p>
                            <p className="is-size-6">
                                {remoteAssessment
                                    ? longLocalizedDate(assessment.sentAt ?? assessment.scheduledFor)
                                    : format(new Date(assessment.scheduledFor), "PP")}
                            </p>
                            <p className="is-size-6">
                                {remoteAssessment && assessment.linkStatus ? parseStatus(assessment.linkStatus) : ""}
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </a>
    );
};

interface AssessmentBoxProps {
    assessment: UpcomingAssessment & { sentAt?: string; linkStatus?: AssessmentStatus };
    isFirst?: boolean;
    isLast?: boolean;
    lastDate?: boolean;
    remoteAssessment?: boolean;
    onSelected?: () => void;
}
